import styled from 'styled-components';

const ChipContainerStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 8px 2px 8px;
  border-radius: 16px;
  background: #dbcce8;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #4d008c;
`;

export default ChipContainerStyled;
